/**
 * Created by rathompson on 5/23/22
 * File: AssociateAppsSidebar
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { useCallback, useEffect } from 'react'
import { Bold, Body, Radio, RadioGroup } from '@panwds/react-ui'
import { LABEL_LICENSED_PRODUCTS } from '../../../../constants/LabelConstants'
import { useContext, useMemo, useState } from 'react'
import AppContext from '../../../../../common/context/AppContext'
import { getDasAppDisplay, isNonemptyArray, isRunningStatus } from '../../../../../common/utils/Utils'

const AssociateAppsSidebar = ({
  products: _products = [],
  setSelectedApp = () => null,
}) => {

  const { apps, getAppName } = useContext(AppContext)
  const [selectedProduct, setSelectedProduct] = useState(null)

  useEffect(() => {
    setSelectedApp(selectedProduct)
  }, [selectedProduct, setSelectedApp])



  const radioRender = useCallback((instance, index, selectedProduct) => {
    const isInstanceRunning = isRunningStatus(instance)
    const dasAppDetails = getDasAppDisplay(instance, apps, getAppName)
    return <Radio
      key={index}
      value={JSON.stringify(instance)}
      disabled={!isInstanceRunning}
      checked={ isInstanceRunning && selectedProduct?.app_id === instance?.app_id}
    >
      <Body addClassName={ !isInstanceRunning && 'tw-text-secondary' }>{dasAppDetails.appName}</Body>
      {dasAppDetails?.sub_title && <Body addClassName='tw-text-secondary'>{dasAppDetails.sub_title}</Body>}
      {!isInstanceRunning && <Body addClassName='tw-text-secondary'>{`Disabled due to ${instance?.status || 'no'} status`}</Body>}
    </Radio>
  }, [apps, getAppName])

  const products = useMemo(() => {
    return (
      <RadioGroup
        name="products"
        onChange={event => setSelectedProduct(JSON.parse(event.target.value))}
      >
        <div className='tw-p-3 tw-flex tw-flex-col tw-gap-4'>
          {_products.map((product, index) => radioRender(product, index, selectedProduct))}
        </div>
      </RadioGroup>
    )
  }, [_products, radioRender, selectedProduct])

  return (
    <div className="tw-p-3 tw-whitespace-nowrap tw-flex tw-flex-col" style={{ width: '260px' }}>
      {isNonemptyArray(_products) && <>
        <Bold appearance='semibold'>{LABEL_LICENSED_PRODUCTS}</Bold>
        {products}
      </>}
    </div>
  )
}

AssociateAppsSidebar.propTypes = {}
export default AssociateAppsSidebar
